import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {createIssueMutation} from '@github-ui/server-persisted-queries'
import type {
  CreateIssueInput,
  CreateIssueMutationMutation,
} from '@github-ui/server-persisted-queries/types/createIssueMutation'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export type CreateIssueRequest = {
  input: Partial<CreateIssueInput> & Pick<CreateIssueInput, 'repositoryId' | 'title'>
  fetchParent?: boolean
}

export type CreateIssueResponse = GraphQLResponse<CreateIssueMutationMutation>

export async function apiCreateIssue(request: CreateIssueRequest): Promise<CreateIssueResponse> {
  const response = await reactFetchJSON(`/_ghui/issues?queryId=${createIssueMutation}`, {
    method: 'POST',
    body: request,
  })

  return response.json() as Promise<CreateIssueResponse>
}
